/**
 * API call of the shop file's one-order backfill tab, on the generated `InternalAdminApi`.
 *
 * Carries the shop's access grant (`shopGrant`); a refusal for want of one is recognised by
 * `isShopAccessRequired` in the caller, which then asks for a reason again.
 */

import type {
  BackfillInvoiceDto,
  BackfillInvoiceResponseDto,
} from '../../../../libs/api-client/src/generated/models';
import { opsClient, shopGrant } from './ops-api';

// Re-exported from the generated client rather than restated here — see `support-api.ts`.
export type { BackfillInvoiceResponseDto as BackfillInvoiceResponse } from '../../../../libs/api-client/src/generated/models';

/** Creates the missing invoice for one order of the shop. Writes its audit row first. */
export async function backfillInvoice(
  shopId: string,
  body: BackfillInvoiceDto,
): Promise<BackfillInvoiceResponseDto> {
  const { data } = await opsClient().backfillInvoice({
    shopId,
    xOpsShopAccess: shopGrant(shopId),
    backfillInvoiceDto: body,
  });
  return data;
}
